export function formatRp(n: number | null | undefined): string {
    if (n == null || isNaN(Number(n))) return 'Rp 0';
    return 'Rp ' + Math.round(Number(n)).toLocaleString('id-ID');
}
